import React, { useState, useEffect } from 'react';
import './Documents.css';

const DOCUMENTS = [
  {
    id: 'privacy',
    title: 'Политика конфиденциальности',
    content: `
Политика конфиденциальности сервиса RiseVPN
1. Общие положения
1.1. Настоящая Политика конфиденциальности определяет порядок обработки и защиты информации пользователей сервиса RiseVPN.
1.2. Владельцем и оператором Сервиса является:
ОсОО «НОВАПЭЙ»
Адрес: Кыргызская Республика, г. Бишкек, Свердловский район, ул. Киевская, 62
Регистрационный номер: 175671-3301-ООО
ИНН: 9909710276
1.3. Сервис предоставляется через:
•	сайт https://risevpn.cc;
•	Telegram-бот https://t.me/risevpn_bot;
•	приложения и иные технические средства, подключённые к RiseVPN.
1.4. Используя Сервис, Пользователь подтверждает ознакомление с настоящей Политикой и согласие с предусмотренной ею обработкой данных.
2. Термины
2.1. Пользователь — физическое лицо, использующее Сервис.
2.2. Оператор — ОсОО «НОВАПЭЙ».
2.3. Сервис — программное обеспечение и техническая инфраструктура RiseVPN, предоставляемые через сайт, Telegram-бот, приложения и другие средства подключения.
2.4. Персональные данные — информация, прямо или косвенно относящаяся к определённому Пользователю.
2.5. Обработка данных — сбор, хранение, использование, изменение, передача, обезличивание, блокирование, удаление и другие действия с данными.
3. Какие данные обрабатывает Сервис
3.1. Данные учётной записи
•	Telegram ID;
•	имя и никнейм в Telegram;
•	язык интерфейса;
•	контактные данные, добровольно предоставленные Пользователем;
•	сведения об обращениях в поддержку.
3.2. Данные о подписке
•	выбранный тариф;
•	дата активации и окончания подписки;
•	количество разрешённых устройств;
•	созданные конфигурации и ключи;
•	статус подключения;
•	сведения о приобретённых дополнительных услугах.
3.3. Платёжные данные
Оператор может получать:
•	идентификатор платежа;
•	дату и сумму;
•	статус операции;
•	способ оплаты;
•	сведения, необходимые для возврата и проверки платежа.
Полные данные банковской карты Оператором не хранятся. Они обрабатываются платёжной организацией.
3.4. Технические данные
В целях обеспечения работы и безопасности могут обрабатываться:
•	IP-адрес;
•	тип устройства и операционной системы;
•	версия приложения;
•	время обращения к Сервису;
•	сведения об ошибках;
•	технические журналы работы инфраструктуры;
•	информация о превышении лимита устройств или иных технических ограничений.
4. Информация о сетевой активности
RiseVPN не осуществляет целенаправленное хранение:
•	истории посещённых сайтов;
•	содержимого интернет-трафика;
•	переписки Пользователя;
•	передаваемых файлов;
•	содержимого запросов к интернет-ресурсам.
Для обеспечения соединения, безопасности инфраструктуры и предотвращения злоупотреблений может временно обрабатываться минимальная техническая информация, необходимая для работы Сервиса.
5. Цели обработки
Данные обрабатываются для:
•	предоставления доступа к программному обеспечению;
•	создания и обслуживания учётной записи;
•	активации, продления и прекращения подписки;
•	проведения платежей и возвратов;
•	оказания технической поддержки;
•	диагностики ошибок;
•	обеспечения безопасности;
•	предотвращения мошенничества, спама, атак и иных нарушений;
•	исполнения договорных обязательств;
•	направления сервисных уведомлений;
•	соблюдения применимого законодательства.
6. Основания обработки
Основаниями обработки являются:
•	согласие Пользователя;
•	принятие Публичной оферты и Условий использования;
•	необходимость исполнения договора;
•	законный интерес Оператора в обеспечении работы и безопасности Сервиса;
•	требования применимого законодательства.
7. Передача данных
Данные могут передаваться:
•	платёжным организациям;
•	банкам и финансовым партнёрам;
•	поставщикам хостинга;
•	подрядчикам, обслуживающим техническую инфраструктуру;
•	поставщикам сервисов уведомлений;
•	государственным органам при наличии обязательного законного требования.
Получателям передаётся только тот объём данных, который необходим для выполнения соответствующей задачи.
8. Трансграничная обработка
Поскольку серверы, подрядчики и платёжные организации могут находиться в разных странах, данные могут обрабатываться за пределами страны проживания Пользователя.
Оператор принимает разумные меры для обеспечения надлежащего уровня защиты передаваемой информации.
9. Сроки хранения
Данные хранятся не дольше, чем это необходимо для достижения целей обработки.
Сведения о платежах и договорах могут храниться в течение сроков, установленных бухгалтерским, налоговым и иным применимым законодательством.
Технические данные удаляются или обезличиваются после утраты необходимости в их использовании.
10. Защита информации
Оператор применяет разумные меры безопасности, включая:
•	разграничение доступа;
•	использование защищённых соединений;
•	контроль доступа к инфраструктуре;
•	резервное копирование;
•	обновление программного обеспечения;
•	мониторинг технических угроз.
При этом ни один способ передачи и хранения информации не может гарантировать абсолютную безопасность.
11. Права Пользователя
Пользователь может:
•	запросить сведения об обрабатываемых данных;
•	потребовать исправления неточных данных;
•	потребовать удаления данных при наличии оснований;
•	отозвать согласие;
•	ограничить обработку в случаях, предусмотренных законом;
•	направить жалобу или обращение Оператору.
12. Cookies и аналитика
Telegram-бот не использует файлы cookies.
Сайт RiseVPN может использовать технические cookies, необходимые для работы страниц, сохранения настроек и обеспечения безопасности.
Если на сайте используются сторонние системы аналитики, информация об этом должна быть дополнительно размещена на сайте.
13. Уведомления
Оператор вправе отправлять Пользователю сообщения:
•	об оплате;
•	об окончании подписки;
•	о технических работах;
•	об изменениях в работе Сервиса;
•	о безопасности учётной записи;
•	о существенных изменениях документов.
Рекламные сообщения направляются при наличии необходимого согласия или другого законного основания.
14. Изменение Политики
Оператор вправе изменять Политику.
Актуальная версия размещается на сайте и доступна через Telegram-бот. Продолжение использования Сервиса после вступления изменений в силу означает согласие Пользователя с новой редакцией.
15. Контактные данные
ОсОО «НОВАПЭЙ»
Адрес: Кыргызская Республика, г. Бишкек, Свердловский район, ул. Киевская, 62
Регистрационный номер: 175671-3301-ООО
ИНН: 9909710276
Сайт: https://risevpn.cc
Telegram-поддержка: https://t.me/risevpn_help
E-mail: support@riseonline.cc
    `.trim(),
  },
  {
    id: 'terms',
    title: 'Пользовательское соглашение',
    content: `
Условия использования сервиса RiseVPN
1. Общие положения
1.1. Настоящие Условия регулируют порядок использования сервиса RiseVPN, а также права и обязанности Пользователя и Исполнителя.
1.2. Исполнителем является:
ОсОО «НОВАПЭЙ»
Адрес: Кыргызская Республика, г. Бишкек, Свердловский район, ул. Киевская, 62
Регистрационный номер: 175671-3301-ООО
ИНН: 9909710276
1.3. Используя Сервис, нажимая кнопку «Старт», оформляя подписку или совершая оплату, Пользователь подтверждает, что ознакомился с настоящими Условиями и принимает их полностью.
1.4. Если Пользователь не согласен с Условиями, он обязан прекратить использование Сервиса.
2. Описание Сервиса
2.1. RiseVPN предоставляет Пользователю доступ к программному обеспечению и технической инфраструктуре, предназначенным для установления защищённого сетевого соединения.
2.2. Доступ может предоставляться через Telegram-бот, сайт, приложения, конфигурации, ключи и иные технические средства.
2.3. Исполнитель не является владельцем сторонних интернет-ресурсов и не управляет их содержанием.
2.4. Качество работы зависит от внешних обстоятельств, включая:
•	интернет-провайдера Пользователя;
•	мобильного оператора;
•	используемое устройство;
•	операционную систему;
•	приложения для подключения;
•	местонахождение Пользователя;
•	ограничения со стороны третьих лиц;
•	нагрузку и техническое состояние каналов связи.
3. Регистрация и доступ
3.1. Управление подпиской осуществляется через Telegram-бот https://t.me/risevpn_bot и иные интерфейсы RiseVPN.
3.2. Для использования Сервиса Пользователю может потребоваться Telegram-аккаунт и совместимое приложение.
3.3. Пользователь обязан обеспечивать сохранность ключей, ссылок, паролей и иных данных доступа.
3.4. Пользователь несёт ответственность за действия, совершённые с использованием его данных доступа.
3.5. Передача подписки третьим лицам допускается только в пределах установленного тарифом количества устройств и при соблюдении настоящих Условий.
4. Правила использования
Пользователь обязан:
4.1. Соблюдать применимое законодательство.
4.2. Не использовать Сервис для:
•	мошенничества;
•	распространения вредоносного программного обеспечения;
•	несанкционированного доступа к информационным системам;
•	проведения сетевых атак;
•	рассылки спама;
•	нарушения интеллектуальных прав;
•	распространения запрещённой информации;
•	иных противоправных действий.
4.3. Не предпринимать действий, создающих чрезмерную нагрузку на инфраструктуру.
4.4. Не превышать предусмотренное тарифом количество подключённых устройств.
4.5. Не передавать и не перепродавать доступ без письменного разрешения Исполнителя.
4.6. Не пытаться обходить технические ограничения Сервиса, вмешиваться в его работу, изменять программное обеспечение или получать несанкционированный доступ к инфраструктуре.
4.7. Использовать P2P-трафик только на серверах, где это прямо разрешено.
5. Тарифы и оплата
5.1. Действующие тарифы, сроки подписки, лимиты и стоимость публикуются в Telegram-боте и других интерфейсах Сервиса.
5.2. Исполнитель вправе изменять стоимость и состав тарифов. Изменения не уменьшают уже оплаченный период, если иное не требуется законом или не связано с прекращением работы отдельной функции.
5.3. Подписка активируется после подтверждения оплаты платёжной организацией.
5.4. При задержке или ошибке активации Пользователь должен обратиться в поддержку и предоставить сведения, позволяющие идентифицировать платёж.
5.5. Обязательство Пользователя по оплате считается исполненным после подтверждения успешной операции платёжной системой.
6. Автоматическое продление
6.1. Для отдельных способов оплаты Пользователю может быть доступно автоматическое продление подписки.
6.2. Подключая автоматическое продление, Пользователь поручает Исполнителю и платёжной организации инициировать периодические списания стоимости выбранного тарифа.
6.3. Размер списания определяется стоимостью тарифа, действующей на момент очередного продления.
6.4. Информация о подключении автоматического продления должна отображаться до подтверждения платежа.
6.5. Пользователь вправе отключить автоматическое продление через интерфейс Сервиса или обратившись в поддержку.
6.6. Отключение автоматического продления прекращает будущие списания, но не отменяет уже оплаченный период.
6.7. Если списание не прошло, Исполнитель вправе приостановить доступ после завершения оплаченного периода.
7. Права Пользователя
Пользователь вправе:
•	получать услугу в пределах оплаченного тарифа;
•	получать информацию о тарифе и сроке подписки;
•	обращаться в поддержку;
•	отключить автоматическое продление;
•	направить заявление на возврат в соответствии с Политикой возврата;
•	прекратить использование Сервиса в любое время.
8. Права Исполнителя
Исполнитель вправе:
•	изменять функциональность и техническую инфраструктуру;
•	заменять серверы и параметры подключения;
•	проводить технические работы;
•	устанавливать разумные ограничения нагрузки;
•	блокировать доступ при нарушении Условий;
•	запрашивать информацию для проверки платежей и обращений;
•	приостанавливать обслуживание при возникновении угрозы безопасности;
•	обновлять тарифы и документы.
9. Обязанности Исполнителя
Исполнитель обязуется:
•	предоставить доступ в пределах оплаченного тарифа;
•	принимать разумные меры для поддержания работы Сервиса;
•	обрабатывать обращения Пользователей;
•	обеспечивать защиту персональных данных в предусмотренном документами объёме;
•	рассматривать заявления на возврат;
•	предоставлять информацию о существенных условиях подписки.
10. Ограничение ответственности
10.1. Сервис предоставляется по принципу «как есть» с учётом особенностей сетевой инфраструктуры.
10.2. Исполнитель не гарантирует:
•	абсолютную и непрерывную доступность;
•	одинаковую скорость на всех устройствах и сетях;
•	доступность всех сторонних ресурсов;
•	совместимость со всеми устройствами и приложениями;
•	отсутствие ограничений со стороны операторов, провайдеров или государственных органов.
10.3. Исполнитель не отвечает за:
•	действия Пользователя;
•	работу сторонних приложений;
•	качество связи Пользователя;
•	ограничения третьих лиц;
•	утрату Пользователем данных доступа;
•	последствия использования Сервиса с нарушением закона;
•	сбои, вызванные обстоятельствами непреодолимой силы.
10.4. Совокупная ответственность Исполнителя по конкретной услуге ограничивается суммой, фактически уплаченной Пользователем за спорный период, если иное прямо не установлено применимым законодательством.
11. Приостановление доступа
Исполнитель вправе приостановить или прекратить доступ при:
•	нарушении настоящих Условий;
•	превышении лимита устройств;
•	создании вредоносной или чрезмерной нагрузки;
•	использовании Сервиса для противоправных действий;
•	попытке взлома инфраструктуры;
•	получении обязательного требования компетентного органа;
•	наличии признаков мошенничества;
•	окончании оплаченного периода.
В случае серьёзного нарушения доступ может быть прекращён без компенсации, если это не противоречит применимому законодательству.
12. Интеллектуальная собственность
Программные решения, интерфейсы, дизайн, тексты, логотипы и другие элементы RiseVPN принадлежат Исполнителю или используются им на законном основании.
Пользователь не вправе копировать, изменять, распространять, перепродавать или использовать элементы Сервиса вне предусмотренных настоящими Условиями целей.
13. Персональные данные
Обработка данных осуществляется в соответствии с:
•	Политикой конфиденциальности;
•	Согласием на обработку персональных данных;
•	Публичной офертой;
•	применимым законодательством.
14. Возвраты
Порядок, основания и сроки возврата определяются Политикой возврата RiseVPN.
Подача заявления не означает автоматического одобрения возврата. Каждое обращение рассматривается с учётом обстоятельств и требований применимого законодательства.
15. Изменение Условий
Исполнитель вправе изменять настоящие Условия.
Новая редакция публикуется на сайте или в Telegram-боте. Продолжение использования после вступления изменений в силу означает согласие с новой редакцией.
16. Контакты
ОсОО «НОВАПЭЙ»
Адрес: Кыргызская Республика, г. Бишкек, Свердловский район, ул. Киевская, 62
Регистрационный номер: 175671-3301-ООО
ИНН: 9909710276
Сайт: https://risevpn.cc
Telegram-поддержка: https://t.me/risevpn_help
E-mail: support@riseonline.cc
    `.trim(),
  },
  {
    id: 'refund',
    title: 'Политика возврата',
    content: `
Политика возврата RiseVPN
1. Общие положения
1.1. Настоящая Политика определяет порядок возврата денежных средств пользователям RiseVPN.
1.2. Услуги Сервиса предоставляются в цифровом виде. После подтверждения оплаты Пользователю предоставляется доступ к программному обеспечению, конфигурациям и технической инфраструктуре.
1.3. Оплата означает согласие Пользователя с настоящей Политикой, Публичной офертой и Условиями использования.
2. Основания для рассмотрения возврата
Возврат может быть произведён, если:
•	после оплаты доступ не был предоставлен;
•	подписка не активировалась вследствие ошибки Сервиса;
•	Пользователь технически не мог воспользоваться услугой по причине неисправности на стороне RiseVPN;
•	поддержка не смогла устранить подтверждённую проблему в течение 72 часов;
•	произошёл ошибочный повторный платёж;
•	деньги были списаны после своевременного отключения автоматического продления;
•	Сервис был массово недоступен более 24 часов по вине Исполнителя;
•	возврат обязателен в соответствии с применимым законодательством.
3. Когда возврат обычно не производится
Возврат может быть отклонён, если:
•	услуга была активирована и фактически использовалась;
•	Пользователь подключался к Сервису хотя бы один раз, а технических недостатков со стороны RiseVPN не выявлено;
•	проблема вызвана устройством, провайдером, мобильным оператором, сторонним приложением или настройками Пользователя;
•	Пользователь передумал пользоваться Сервисом;
•	Пользователь просит вернуть деньги за частично использованный период без технических оснований;
•	Пользователь нарушил Условия использования;
•	были превышены лимиты устройств;
•	доступ заблокирован за мошенничество, спам, атаки или другую запрещённую деятельность;
•	истёк срок подписки;
•	Пользователь не предоставил данные, необходимые для идентификации платежа;
•	доступ к отдельному стороннему сайту ограничен по причинам, не зависящим от Исполнителя.
Окончательное решение принимается с учётом обстоятельств обращения и обязательных требований применимого законодательства.
4. Срок подачи заявления
Заявление рекомендуется направить в течение 7 календарных дней с даты платежа.
Обращения, поданные позднее, могут рассматриваться при наличии подтверждённой технической неисправности, ошибочного списания или обязательного основания, предусмотренного законом.
5. Порядок обращения
Для возврата Пользователь направляет обращение:
Telegram: https://t.me/risevpn_help
E-mail: support@riseonline.cc
В обращении необходимо указать:
•	Telegram ID или никнейм;
•	дату и сумму платежа;
•	идентификатор операции;
•	способ оплаты;
•	подтверждение платежа;
•	причину обращения;
•	описание технической проблемы;
•	скриншоты или видеозапись ошибки, если это возможно.
6. Рассмотрение заявления
6.1. Заявление рассматривается в течение 3 рабочих дней.
6.2. При необходимости дополнительной проверки срок может быть увеличен до 10 рабочих дней.
6.3. Исполнитель вправе запросить дополнительные сведения.
6.4. При отсутствии достаточных данных заявление может быть оставлено без рассмотрения до предоставления необходимой информации.
7. Способ возврата
Возврат производится тем же способом, которым была выполнена оплата, если это технически возможно.
Срок фактического зачисления зависит от платёжной организации и банка Пользователя и может составлять до 30 календарных дней.
Комиссии платёжных систем учитываются в порядке, установленном применимым законодательством и правилами соответствующей платёжной организации.
8. Последствия возврата
После одобрения возврата:
•	подписка прекращается;
•	доступ блокируется;
•	конфигурации и ключи деактивируются;
•	неиспользованные бонусы аннулируются;
•	Пользователь обязан прекратить использование полученных данных подключения.
9. Контакты
ОсОО «НОВАПЭЙ»
Адрес: Кыргызская Республика, г. Бишкек, Свердловский район, ул. Киевская, 62
Регистрационный номер: 175671-3301-ООО
ИНН: 9909710276
Telegram-поддержка: https://t.me/risevpn_help
E-mail: support@riseonline.cc
    `.trim(),
  },
  {
    id: 'offer',
    title: 'Публичная оферта',
    content: `
Публичная оферта на предоставление услуг RiseVPN
1. Общие положения
1.1. Настоящий документ является публичным предложением ОсОО «НОВАПЭЙ» заключить договор оказания цифровых услуг на изложенных ниже условиях.
1.2. Исполнитель:
ОсОО «НОВАПЭЙ»
Адрес: Кыргызская Республика, г. Бишкек, Свердловский район, ул. Киевская, 62
Регистрационный номер: 175671-3301-ООО
ИНН: 9909710276
1.3. Акцептом Оферты является:
•	оплата услуги;
•	нажатие кнопки подтверждения;
•	активация подписки;
•	получение конфигурации;
•	начало использования Сервиса.
1.4. Акцепт означает полное и безоговорочное принятие Оферты.
2. Термины
2.1. Сервис — RiseVPN, предоставляемый через сайт, Telegram-бот, приложения, конфигурации и техническую инфраструктуру.
2.2. Исполнитель — ОсОО «НОВАПЭЙ».
2.3. Пользователь — дееспособное лицо, принявшее Оферту.
2.4. Услуга — предоставление доступа к программному обеспечению на выбранный Пользователем период.
2.5. Подписка — право использования Сервиса в течение оплаченного периода в пределах выбранного тарифа.
2.6. Тариф — совокупность стоимости, срока, лимита устройств, трафика и иных условий.
2.7. Автоматическое продление — периодическое списание стоимости тарифа на основании отдельного согласия Пользователя.
3. Предмет договора
3.1. Исполнитель обязуется предоставить Пользователю доступ к программному обеспечению в соответствии с выбранным тарифом, а Пользователь обязуется оплатить услугу.
3.2. Услуга может включать:
•	создание подписки;
•	предоставление конфигураций и ключей;
•	возможность подключения к инфраструктуре RiseVPN;
•	доступ к предусмотренным тарифом локациям;
•	техническую поддержку;
•	дополнительные функции, указанные в интерфейсе Сервиса.
3.3. Услуга предоставляется дистанционно в цифровом виде.
3.4. Исполнитель считается приступившим к оказанию услуги с момента активации подписки или предоставления данных подключения.
4. Порядок оформления
4.1. Пользователь выбирает тариф через Telegram-бот или другой интерфейс Сервиса.
4.2. До оплаты Пользователю предоставляется информация о:
•	стоимости;
•	сроке подписки;
•	лимите устройств;
•	применимых ограничениях;
•	наличии автоматического продления.
4.3. После подтверждения платежа подписка активируется автоматически или вручную.
4.4. Пользователь обязан проверить правильность выбранного тарифа до оплаты.
5. Цена и расчёты
5.1. Цена определяется тарифом, действующим на момент оплаты.
5.2. Стоимость указывается в интерфейсе Сервиса.
5.3. Оплата проводится через доступные платёжные способы.
5.4. Исполнитель не получает полные реквизиты банковской карты.
5.5. Комиссия может взиматься банком или платёжной организацией в соответствии с их правилами.
5.6. Исполнитель вправе изменять цены на будущие периоды. Изменение цены не изменяет уже оплаченный срок.
6. Рекуррентные платежи
6.1. Автоматическое продление подключается только после совершения Пользователем действия, подтверждающего согласие на периодические списания.
6.2. Пользователь поручает Исполнителю и платёжной организации списывать стоимость тарифа с сохранённого платёжного средства перед началом очередного периода.
6.3. Периодичность списаний соответствует выбранному тарифу.
6.4. Размер следующего платежа определяется стоимостью тарифа на дату продления.
6.5. Пользователь может отменить автоматическое продление:
•	через интерфейс Telegram-бота;
•	через личный кабинет, если он предусмотрен;
•	через службу поддержки.
6.6. Отмена должна быть выполнена до инициирования очередного платежа.
6.7. Отмена не является основанием для возврата суммы за уже начавшийся оплаченный период, кроме случаев, предусмотренных Политикой возврата или законом.
6.8. При неуспешном списании Исполнитель вправе повторно инициировать платёж либо прекратить доступ после завершения оплаченного периода.
7. Права и обязанности Пользователя
Пользователь обязан:
•	предоставить достоверные сведения;
•	оплатить выбранную услугу;
•	соблюдать Условия использования;
•	не передавать доступ с нарушением тарифа;
•	не использовать Сервис в противоправных целях;
•	обеспечивать сохранность данных подключения;
•	своевременно отключить автоматическое продление при отказе от будущих списаний.
Пользователь вправе:
•	пользоваться Сервисом в пределах тарифа;
•	получать информацию о подписке;
•	обращаться в поддержку;
•	отказаться от автоматического продления;
•	направить заявление на возврат.
8. Права и обязанности Исполнителя
Исполнитель обязан:
•	активировать оплаченную подписку;
•	предоставить доступ в предусмотренном тарифом объёме;
•	обрабатывать обращения;
•	обеспечивать разумную защиту персональных данных;
•	рассматривать заявления на возврат.
Исполнитель вправе:
•	изменять инфраструктуру;
•	проводить технические работы;
•	заменять серверы;
•	вводить ограничения для защиты стабильности;
•	приостанавливать доступ при нарушениях;
•	изменять тарифы на будущие периоды;
•	привлекать подрядчиков.
9. Порядок сдачи и приёмки услуги
9.1. Услуга считается предоставленной после активации подписки и появления технической возможности подключения.
9.2. Если Пользователь не сообщил о невозможности получить доступ в разумный срок после оплаты, услуга считается принятой без замечаний.
9.3. Фактическое использование Сервиса подтверждает получение доступа.
9.4. Отсутствие использования по личным причинам Пользователя не означает, что услуга не была предоставлена.
10. Возвраты
10.1. Возвраты осуществляются в соответствии с Политикой возврата.
10.2. Для рассмотрения обращения Пользователь обязан предоставить сведения о платеже и обстоятельствах требования.
10.3. После возврата подписка и выданные конфигурации прекращают действие.
11. Ответственность
11.1. Стороны несут ответственность в соответствии с Офертой и применимым законодательством.
11.2. Исполнитель не отвечает за невозможность использования, вызванную:
•	устройством Пользователя;
•	сторонним приложением;
•	интернет-провайдером;
•	мобильным оператором;
•	ограничениями третьих лиц;
•	действиями государственных органов;
•	форс-мажором;
•	нарушением Пользователем инструкций.
11.3. Исполнитель не гарантирует доступность каждого стороннего ресурса.
11.4. Ответственность Исполнителя ограничивается суммой, уплаченной за соответствующий период, кроме случаев, когда иное обязательно установлено законом.
12. Срок действия и прекращение
12.1. Договор вступает в силу с момента акцепта.
12.2. Договор действует до окончания оплаченной подписки и исполнения обязательств.
12.3. При автоматическом продлении действие договора продлевается на каждый оплаченный период.
12.4. Пользователь вправе прекратить использование в любое время.
12.5. Исполнитель вправе прекратить доступ при нарушении Оферты или Условий использования.
13. Персональные данные
13.1. Обработка данных производится в соответствии с Политикой конфиденциальности и Согласием на обработку персональных данных.
13.2. Акцептуя Оферту, Пользователь подтверждает ознакомление с указанными документами.
14. Урегулирование споров
14.1. До обращения в суд сторона направляет другой стороне письменную или электронную претензию.
14.2. Исполнитель рассматривает претензию в разумный срок, если иной срок не установлен применимым законодательством.
14.3. Неурегулированные споры рассматриваются в соответствии с применимым законодательством и правилами подсудности.
15. Изменение Оферты
15.1. Исполнитель вправе изменять Оферту.
15.2. Новая редакция применяется к отношениям, возникшим после её публикации, а также к последующим периодам продления.
15.3. Актуальная редакция размещается на сайте и доступна через Telegram-бот.
16. Реквизиты Исполнителя
ОсОО «НОВАПЭЙ»
Адрес: Кыргызская Республика, г. Бишкек, Свердловский район, ул. Киевская, 62
Регистрационный номер: 175671-3301-ООО
ИНН: 9909710276
Сервис: RiseVPN
Сайт: https://risevpn.cc
Telegram-поддержка: https://t.me/risevpn_help
E-mail: support@riseonline.cc
    `.trim(),
  },
  {
    id: 'consent',
    title: 'Согласие на обработку персональных данных',
    content: `
Согласие на обработку персональных данных RiseVPN
Настоящее Согласие на обработку персональных данных далее — «Согласие» предоставляется пользователем сервиса RiseVPN свободно, своей волей и в своих интересах.
Используя Telegram-бот RiseVPN по адресу https://t.me/risevpn_bot, сайт https://risevpn.сс, оформляя подписку или взаимодействуя с сервисом иным способом, Пользователь предоставляет ОсОО «НОВАПЭЙ», далее — «Оператор», согласие на обработку своих персональных данных на условиях, изложенных ниже.
1. Сведения об Операторе
ОсОО «НОВАПЭЙ»
Адрес: Кыргызская Республика, г. Бишкек, Свердловский район, ул. Киевская, 62
Регистрационный номер: 175671-3301-ООО
ИНН: 9909710276
Сервис: RiseVPN
Сайт: https://risevpn.cc
Telegram-поддержка: https://t.me/risevpn_help
E-mail: [E-MAIL]
2. Персональные данные, на обработку которых предоставляется согласие
Оператор вправе обрабатывать следующие данные Пользователя:
2.1. Данные, предоставляемые Пользователем
•	Telegram ID;
•	имя и никнейм, указанные в Telegram;
•	адрес электронной почты, если он был указан Пользователем;
•	контактные данные, добровольно переданные службе поддержки;
•	информация о выбранном тарифе и приобретённых услугах;
•	сведения, содержащиеся в обращениях в службу поддержки.
2.2. Данные, передаваемые автоматически
•	техническая информация об устройстве;
•	IP-адрес, необходимый для технической работы и защиты Сервиса;
•	время подключения и технические события;
•	сведения об ошибках подключения;
•	сведения о факте оплаты: идентификатор, дата, сумма и статус платежа;
•	срок действия подписки и количество подключённых устройств.
Оператор не получает и не хранит полные реквизиты банковских карт Пользователя. Обработка платёжных реквизитов осуществляется платёжными организациями.
Оператор не обрабатывает и не хранит содержимое интернет-трафика Пользователя, историю посещённых сайтов, переписку, передаваемые файлы и содержание сетевых запросов, кроме случаев, когда техническая обработка отдельных данных необходима для работы Сервиса или исполнения требований применимого законодательства.
3. Цели обработки данных
Персональные данные могут обрабатываться для следующих целей:
•	предоставление доступа к программному обеспечению;
•	регистрация и идентификация Пользователя;
•	создание, активация и продление подписки;
•	обработка платежей и возвратов;
•	выполнение условий Пользовательского соглашения и Публичной оферты;
•	оказание технической поддержки;
•	обеспечение безопасности Сервиса;
•	предотвращение мошенничества и злоупотреблений;
•	отправка сервисных уведомлений;
•	улучшение стабильности и качества работы Сервиса;
•	исполнение требований применимого законодательства.
4. Действия с персональными данными
Оператор вправе осуществлять следующие действия:
•	сбор;
•	запись;
•	систематизацию;
•	накопление;
•	хранение;
•	уточнение и обновление;
•	использование;
•	обезличивание;
•	блокирование;
•	удаление;
•	уничтожение.
Обработка может осуществляться с использованием средств автоматизации или без их использования.
5. Передача данных третьим лицам
Передача персональных данных допускается только в объёме, необходимом:
•	платёжным организациям — для проведения платежей и возвратов;
•	техническим подрядчикам — для работы инфраструктуры Сервиса;
•	поставщикам хостинга, облачных и коммуникационных услуг;
•	государственным органам — при наличии законного и обязательного требования;
•	иным лицам — при наличии согласия Пользователя либо другого законного основания.
Оператор не продаёт персональные данные и не передаёт их третьим лицам для самостоятельной рекламы без отдельного согласия Пользователя.
6. Срок хранения данных
Данные хранятся в течение срока использования Сервиса, а после прекращения использования — в течение срока, необходимого для:
•	обработки претензий;
•	разрешения споров;
•	исполнения требований бухгалтерского, налогового и иного применимого законодательства;
•	предотвращения мошенничества.
После достижения целей обработки данные удаляются, обезличиваются или уничтожаются, если их дальнейшее хранение не требуется по закону.
7. Защита данных
Оператор принимает разумные организационные и технические меры для защиты данных от:
•	неправомерного доступа;
•	изменения;
•	утраты;
•	уничтожения;
•	копирования;
•	распространения;
•	иных неправомерных действий.
8. Права Пользователя
Пользователь вправе:
•	получать информацию об обработке своих данных;
•	требовать уточнения неточных данных;
•	требовать блокирования или удаления данных при наличии законных оснований;
•	отозвать настоящее Согласие;
•	обратиться к Оператору по вопросам обработки данных.
Удаление данных, необходимых для работы учётной записи или исполнения договора, может сделать дальнейшее использование Сервиса невозможным.
9. Отзыв Согласия
Пользователь может отозвать Согласие, направив обращение:
•	через Telegram-поддержку: https://t.me/risevpn_help;
•	по электронной почте: support@riseonline.cc.
Оператор вправе продолжить обработку отдельных данных после отзыва Согласия, если их обработка необходима для исполнения требований законодательства, защиты прав Оператора, исполнения уже заключённого договора или разрешения спора.
10. Принятие Согласия
Согласие считается предоставленным, если Пользователь совершил одно или несколько действий:
•	запустил Telegram-бот RiseVPN;
•	нажал кнопку «Старт»;
•	зарегистрировался в Сервисе;
•	оформил или оплатил подписку;
•	подтвердил согласие нажатием соответствующей кнопки;
•	продолжил использование Сервиса после ознакомления с документом.
11. Заключительные положения
Согласие действует до достижения целей обработки или до его отзыва Пользователем, если другой срок не установлен применимым законодательством.
Оператор вправе обновлять документ. Новая редакция вступает в силу с момента публикации на сайте или в Telegram-боте, если в документе не указан иной срок.
Актуальная редакция Согласия размещается на сайте RiseVPN и доступна через Telegram-бот.
    `.trim(),
  },
];

const Documents = ({ publicMode = false }) => {
  const [selectedId, setSelectedId] = useState(null);

  useEffect(() => {
    const path = window.location.pathname;
    const hash = window.location.hash.replace('#', '');

    if (path.startsWith('/documents/')) {
      const id = path.split('/documents/')[1]?.split('/')[0];
      if (id && DOCUMENTS.some((d) => d.id === id)) {
        setSelectedId(id);
        return;
      }
    }

    if (path === '/documents') {
      setSelectedId(null);
      return;
    }

    if (hash && DOCUMENTS.some((d) => d.id === hash)) {
      setSelectedId(hash);
    }
  }, []);

  const openDoc = (id) => {
    setSelectedId(id);
    if (publicMode) {
      window.history.pushState(null, '', `/documents/${id}`);
    } else {
      window.location.hash = id;
    }
  };

  const closeDoc = () => {
    setSelectedId(null);
    if (publicMode) {
      window.history.pushState(null, '', '/documents');
    } else {
      window.history.replaceState(null, '', window.location.pathname + window.location.search);
    }
  };

  const handleSupportClick = () => {
    window.open('https://t.me/risevpn_help', '_blank', 'noopener,noreferrer');
  };

  const selectedDoc = DOCUMENTS.find((d) => d.id === selectedId);

  if (selectedDoc) {
    return (
      <div className="doc-view">
        <button className="doc-back-btn" onClick={closeDoc} type="button">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M15 18l-6-6 6-6" />
          </svg>
          Назад к списку
        </button>

        <h2 className="doc-view-title">{selectedDoc.title}</h2>

        <div className="doc-view-content">
          {selectedDoc.content.split('\n').map((line, i) => (
            <p key={i}>{line || <br />}</p>
          ))}
        </div>

        <button className="docs-support-btn" onClick={handleSupportClick} type="button">
          <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#4aae88" strokeWidth="1.7" strokeLinejoin="round">
            <path d="M4 5h16v11H8l-4 4z" />
          </svg>
          Техподдержка
        </button>
      </div>
    );
  }

  return (
    <div>
      <div className="docs-list">
        {DOCUMENTS.map((doc) => (
          <a
            key={doc.id}
            href={publicMode ? `/documents/${doc.id}` : `#${doc.id}`}
            className="doc-item"
            onClick={(e) => {
              e.preventDefault();
              openDoc(doc.id);
            }}
          >
            <span>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#4aae88" strokeWidth="1.7">
                <path d="M6 3h8l4 4v14H6z" />
                <path d="M14 3v4h4" />
              </svg>
              {doc.title}
            </span>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#4aae88" strokeWidth="1.8">
              <path d="M7 17L17 7M9 7h8v8" />
            </svg>
          </a>
        ))}
      </div>
      <button className="docs-support-btn" onClick={handleSupportClick} type="button">
        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#4aae88" strokeWidth="1.7" strokeLinejoin="round">
          <path d="M4 5h16v11H8l-4 4z" />
        </svg>
        Техподдержка
      </button>
    </div>
  );
};

export default Documents;
export { DOCUMENTS };